<portal-context-switcher
  [disabled]="isAllowedToSwitch === false"
  [entries]="entries$ | async"
  [placeholder]="'user.breadcrumbSwitcher.placeholder' | translate"
  (valueChanged)="trigger($event)"
  initialRoute="end-user"
  switchParameter="userId"
>
  <ng-template let-selected>
    <div class="nav-item__context" role="button">
      <span class="text-truncate">{{ selected.value }}</span>
      <i class="far fa-angle-down nav-item__context-icon"></i>
    </div>
  </ng-template>
</portal-context-switcher>
